import { createStyles, makeStyles } from '@material-ui/core';
import { ExtendedTheme, Link } from 'neon-design-system';
import React from 'react';

const useStyles = makeStyles<ExtendedTheme>((theme) => createStyles({
	inheritFont: {
		fontSize: 'inherit'
	}
}));

export const EmailNeonSales = () => {
	const classes= useStyles();
	return <Link className={classes.inheritFont} ignoreRouter to="mailto:neonsales@marex.com">
		neonsales@marex.com
	</Link>;
}